import * as React from "react";
import BaseLayout from "../../components/BaseLayout";
import Faq from "../../features/Faq";
import FaqPageFilter from "../../features/Faq/FaqPageFilter";

function HomeScreen() {
  return (
    <BaseLayout paddingTop>
      <FaqPageFilter />

      <Faq />
    </BaseLayout>
  );
}

export default HomeScreen;
